import useTranslation from 'next-translate/useTranslation'
import React from 'react'

import Caption from '@/components/ui/Typo/Caption'
import Description from '@/components/ui/Typo/Description'
import H2 from '@/components/ui/Typo/H2'
import { APP_NAME } from '@/res/consts'
import {
  IconDomainServiceItem1,
  IconDomainServiceItem2,
  IconDomainServiceItem3,
} from '@/res/icons'
import { NAMESPACE_DOMAIN } from '@/res/namespaces'

const ServiceSection = () => {
  const { t } = useTranslation(NAMESPACE_DOMAIN)
  const items = [
    {
      Icon: IconDomainServiceItem1.src,
      desc: t('service.domain_brocker'),
      text: t('service.help'),
    },
    {
      Icon: IconDomainServiceItem2.src,
      desc: t('service.domain_transfer'),
      text: t('service.auto_transfer'),
    },
    {
      Icon: IconDomainServiceItem3.src,
      desc: t('service.domain_store'),
      text: t('service.choose_domain'),
    },
  ]
  return (
    <div className="container my-10">
      <H2 uppercase={false} weight="font-bold" color="text-primary">
        {t('why.why_uztelecom', { appName: APP_NAME })}
      </H2>
      <div className="laptop:flex flex-row justify-between my-8">
        {items.map(({ Icon, desc, text }) => (
          <BoxCard icon={Icon} desc={desc} text={text} key={text} />
        ))}
      </div>
    </div>
  )
}
interface IBoxCard {
  icon: any
  desc: string
  text: string
}

const BoxCard: React.FC<IBoxCard> = ({ icon, text, desc }) => {
  return (
    <div className="desktop:py-9 desktop:px-8 py-5 px-4 rounded shadow-md hover:shadow-xl transition ease-out laptop:w-[calc(33.3%-36px)] ">
      <div className="h-11 small:mb-4 mb-2 flex items-center laptop:justify-center small:justify-start justify-center">
        <img src={icon} alt={desc} className="mr-4" />
      </div>
      <Description weight="font-semibold" className="mt-2 mb-3 text-center">
        {desc}
      </Description>
      <Caption color="text-gray3">{text}</Caption>
    </div>
  )
}
export default ServiceSection
